<template>
  <v-row class="contact py-12" no-gutters>
    <v-col md="6" offset-md="3" class="px-6 px-md-0">
      <v-form ref="form" v-model="form.valid">
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="form.nom"
              label="Nom"
              prepend-icon="fa-user"
              color="black"
              filled
              hide-details
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.prenom"
              label="Prénom"
              prepend-icon="fa-user"
              color="black"
              filled
              hide-details
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="form.mail"
              label="Mail"
              prepend-icon="fa-at"
              color="black"
              filled
              hide-details
              :rules="[rules.required, rules.email]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              v-model="form.content"
              label="Message"
              prepend-icon="fa-comment"
              color="black"
              filled
              hide-details
              :rules="[rules.required]"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row class="text-right">
          <v-col>
            <v-btn
              :disabled="!form.valid"
              :color="buttonSendColor"
              class="white--text"
              @click="sendMail"
              :loading="loading"
              >
              <v-icon class="mx-6" v-text="buttonSendIcon"></v-icon>
              </v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "contact",
  data: () => ({
    loading: false,
    form: {
      valid: false,
      nom: null,
      prenom: null,
      mail: null,
      content: null,
    },
    rules: {
      required: (value) => !!value || "Required.",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    },
    buttonSendColor: "#3F3E40",
    buttonSendIcon: "fa-paper-plane"
  }),
  methods: {
    customSendButton(color, icon) {
      this.buttonSendColor = color;
      this.buttonSendIcon = icon;
    },
    async sendMail() {
      this.loading = true;
      const data = new FormData();
      for (const i in this.form) {
        data.append(i, this.form[i]);
      }
      const params = {
        method: "POST",
        body: data,
      };
      let response = await fetch("mailer.php", params);
      let body = await response.json();
      if (body) {
        this.customSendButton("success", "fa-check")
        this.loading = false;
        setTimeout(() => {
          this.$refs.form.reset();
          this.customSendButton("#3F3E40", "fa-paper-plane")
        }, 3000);
      } else {
        this.customSendButton("error", "fa-exclamation-triangle")
        this.loading = false;
        setTimeout(() => {
          this.customSendButton("#3F3E40", "fa-paper-plane")
        }, 3000);
      }
    },
  },
};
</script>

<style scoped>
.contact {
  background: #f2ecd8;
}
</style>